function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function warnIfDeprecated(deprecations) {
  return function Wrapper(WrappedComponent) {
    var WarnIfDeprecatedComp =
    /*#__PURE__*/
    function (_Component) {
      _inherits(WarnIfDeprecatedComp, _Component);

      function WarnIfDeprecatedComp(props) {
        var _this;

        _classCallCheck(this, WarnIfDeprecatedComp);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WarnIfDeprecatedComp).call(this, props));

        if (process.env.NODE_ENV !== 'production' && deprecations.length) {
          var count = 0;
          deprecations.forEach(function (item) {
            // eslint-disable-next-line react/destructuring-assignment
            if (_this.props[item.oldProp]) {
              console.warn("Warning: ".concat(item.oldProp, " has been renamed, and is not recommended for use.\n\n* Rename ").concat(item.oldProp, " to ").concat(item.newProp, " to suppress this warning."));
              count += 1;
            }
          });

          if (count) {
            console.warn("Please update the following components: ".concat(getDisplayName(WrappedComponent)));
          }
        }

        return _this;
      }

      _createClass(WarnIfDeprecatedComp, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              forwardedRef = _this$props.forwardedRef,
              other = _objectWithoutProperties(_this$props, ["forwardedRef"]);

          var rest = other;
          return React.createElement(WrappedComponent, _extends({
            ref: forwardedRef
          }, rest));
        }
      }]);

      return WarnIfDeprecatedComp;
    }(Component);

    var forwardRefComp = function forwardRefComp(props, ref) {
      return React.createElement(WarnIfDeprecatedComp, _extends({}, props, {
        forwardedRef: ref
      }));
    };

    forwardRefComp.displayName = 'ForwardedRefComp';
    hoistNonReactStatic(forwardRefComp, WrappedComponent);
    var forwardCps = React.forwardRef(forwardRefComp);
    return forwardCps;
  };
}